import * as yup from 'yup';

export const DateRangeSchema = yup.object({
  from: yup.date().optional(),
  until: yup.date().optional(),
});

export type IDateRange = {
  from?: Date;
  until?: Date;
};
